import { ReactionType } from "../components/post/interfaces/types";

export const REACTIONS: {
  type: ReactionType;
  icon: string;
  label: string;
  color: string;
}[] = [
  { type: "like", icon: "mdi:thumb-up", label: "Like", color: "text-blue" },
  { type: "love", icon: "mdi:heart", label: "Love", color: "text-error" },
  { type: "haha", icon: "mdi:emoticon-happy", label: "Haha", color: "text-warning" },
  { type: "wow", icon: "mdi:emoticon-surprised", label: "Wow", color: "text-warning" },
  { type: "sad", icon: "mdi:emoticon-cry", label: "Sad", color: "text-warning" },
  { type: "angry", icon: "mdi:emoticon-angry", label: "Angry", color: "text-warning" },
];
